function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "assets/Icons/delete");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "assets/Icons/delete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.8359375,23.9140625 C23.171875,23.5625 23.1796875,22.9921875 22.8359375,22.65625 L18.0546875,17.8671875 L22.8359375,13.0859375 C23.1796875,12.75 23.1796875,12.171875 22.8359375,11.828125 C22.484375,11.4921875 21.9140625,11.484375 21.578125,11.8203125 L16.7890625,16.609375 L12.0078125,11.8203125 C11.6796875,11.4921875 11.0859375,11.4765625 10.75,11.828125 C10.40625,12.171875 10.4140625,12.7578125 10.7421875,13.0859375 L15.53125,17.8671875 L10.7421875,22.65625 C10.4140625,22.984375 10.3984375,23.5703125 10.75,23.9140625 C11.09375,24.2578125 11.6796875,24.25 12.0078125,23.921875 L16.7890625,19.1328125 L21.578125,23.921875 C21.9140625,24.2578125 22.4921875,24.2578125 22.8359375,23.9140625 Z",
  id: "delete",
  fill: "#3C4043",
  fillRule: "nonzero"
}));

var SvgDeleteGrey = function SvgDeleteGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-grey.d16c6068.svg";
export { ForwardRef as ReactComponent };